module.exports = __webpack_public_path__ + "static/img/home_4.bf37d0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_new/home_4.jpg
// module id = SXzH
// module chunks = 6